var _circle, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseNameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D0FFF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_18268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 26.7578C14.3375 26.7578 13.9844 26.6109 13.6906 26.3172C13.3969 26.0234 13.25 25.6703 13.25 25.2578V14.7578C13.25 14.3453 13.3969 13.9922 13.6906 13.6984C13.9844 13.4047 14.3375 13.2578 14.75 13.2578H17.9C18.0625 12.8078 18.3344 12.4453 18.7156 12.1703C19.0969 11.8953 19.525 11.7578 20 11.7578C20.475 11.7578 20.9031 11.8953 21.2844 12.1703C21.6656 12.4453 21.9375 12.8078 22.1 13.2578H25.25C25.6625 13.2578 26.0156 13.4047 26.3094 13.6984C26.6031 13.9922 26.75 14.3453 26.75 14.7578V25.2578C26.75 25.6703 26.6031 26.0234 26.3094 26.3172C26.0156 26.6109 25.6625 26.7578 25.25 26.7578H14.75ZM14.75 25.2578H25.25V14.7578H14.75V25.2578ZM16.25 23.7578H21.5V22.2578H16.25V23.7578ZM16.25 20.7578H23.75V19.2578H16.25V20.7578ZM16.25 17.7578H23.75V16.2578H16.25V17.7578ZM20 14.1953C20.1625 14.1953 20.2969 14.1422 20.4031 14.0359C20.5094 13.9297 20.5625 13.7953 20.5625 13.6328C20.5625 13.4703 20.5094 13.3359 20.4031 13.2297C20.2969 13.1234 20.1625 13.0703 20 13.0703C19.8375 13.0703 19.7031 13.1234 19.5969 13.2297C19.4906 13.3359 19.4375 13.4703 19.4375 13.6328C19.4375 13.7953 19.4906 13.9297 19.5969 14.0359C19.7031 14.1422 19.8375 14.1953 20 14.1953Z",
    fill: "#07213C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseNameIcon);
export default __webpack_public_path__ + "static/media/case-name-icon.9d7c5402bdd49e0496b7d72d74577e98.svg";
export { ForwardRef as ReactComponent };